// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Mqur","header":"PatientQuestionnaire_header__2ecV6","info":"PatientQuestionnaire_info__3M8O8"};